import { inject } from 'mobx-react';
import * as React from 'react';
import { ErrorBoundary } from 'bernie-view';
import { PropertySingleOffer } from '@shared-ui/lodging-property-offers';
import { RefTarget } from '@shared-ui/ref-context';
import { isPetsAmenityFilterPresent } from 'src/common/utils/pets-utils';
import { withSharedUiPropertyOffers } from './shared-ui-property-offers';
import { SingleOfferSearchForm } from 'components/infosite/single-offer-search';
export const PropertySingleOfferWrapper = inject('context', 'currentHotel')(({
  context,
  currentHotel,
  inputs
}) => {
  currentHotel && React.useEffect(() => {
    currentHotel.showPetsOnSingleOffer = isPetsAmenityFilterPresent(context, currentHotel);
  }, []);
  return React.createElement("div", null, React.createElement(RefTarget, {
    name: "Offers",
    tabIndex: 0
  }, React.createElement(ErrorBoundary, {
    label: "lodging.pdp.single.offer"
  }, React.createElement(PropertySingleOffer, {
    inputs: inputs,
    skipSsr: true
  }, React.createElement(SingleOfferSearchForm, null)))));
});
PropertySingleOfferWrapper.displayName = 'PropertySingleOfferWrapper';
export const SharedUiPropertySingleOfferWrapper = withSharedUiPropertyOffers(PropertySingleOfferWrapper);